import { useState } from "react";
import Sidebar from "./components/molecules/Sidebar";
import StoreInputPage from "./pages/StoreInputPage";
import OfficeInputPage from "./pages/OfficeInputPage";
import CommentCheckPage from "./pages/CommentCheckPage";
import LockManagementPage from "./pages/LockManagementPage";
import ShopManagementPage from "./pages/ShopManagementPage";
import AccountPage from "./pages/AccountPage";
import MonthlyDataPage from "./pages/MonthlyDataPage";
import LoginPage from "./pages/LoginPage";
import { isLoggedIn, logout, getCurrentUser } from "./services/authService";

// TODO: モバイル対応時にインポートして使用する
// import { useIsMobile } from './hooks/useWindowSize';

const PAGE_COMPONENTS = {
  store: StoreInputPage,
  office: OfficeInputPage,
  comments: CommentCheckPage,
  lockManagement: LockManagementPage,
  shopManagement: ShopManagementPage,
  monthly: MonthlyDataPage,
  account: AccountPage,
};

// 日本時間での現在日付を YYYYMMDD 形式で返す
const getJapanDateYYYYMMDD = () => {
  const jst = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Tokyo" }),
  );
  const y = jst.getFullYear();
  const m = String(jst.getMonth() + 1).padStart(2, "0");
  const d = String(jst.getDate()).padStart(2, "0");
  return `${y}${m}${d}`;
};

// 初期表示ページを決定する: officeロールは店舗入力画面にアクセスできないため
// 全店舗データ管理画面をデフォルトにする（shop・developはstoreのまま）
const getDefaultPage = () => {
  const user = getCurrentUser();
  return user?.userType === "office" ? "office" : "store";
};

function App() {
  const [loggedIn, setLoggedIn] = useState(isLoggedIn());
  const [currentPage, setCurrentPage] = useState(getDefaultPage);
  // 店舗入力ページ・月毎一覧ページで共有する選択中の日付
  const [currentDate, setCurrentDate] = useState(getJapanDateYYYYMMDD);

  // ログインしていない場合はログインページを表示
  if (!loggedIn) {
    return (
      <LoginPage
        onLogin={() => {
          // ログイン直後はuseStateの初期値が古いため、改めてデフォルトページを設定する
          setCurrentPage(getDefaultPage());
          setLoggedIn(true);
        }}
      />
    );
  }

  const handleLogout = () => {
    logout();
    setLoggedIn(false);
  };

  // 月毎一覧の「編集」ボタンから店舗入力ページへ遷移する際に使用
  const navigateToStore = (date) => {
    setCurrentDate(date);
    setCurrentPage("store");
  };

  const user = getCurrentUser();
  const PageComponent = PAGE_COMPONENTS[currentPage];

  // TODO: モバイルレイアウトの実装
  // const isMobile = useIsMobile();
  // if (isMobile) {
  //   return <MobileLayout currentPage={currentPage} onPageChange={setCurrentPage} />;
  // }

  return (
    <div className="min-h-screen flex flex-col">
      {/* タイトルバー */}
      <header className="border-b border-gray-300 px-6 py-4">
        <h1 className="text-xl font-medium text-gray-700">
          ゆふ小町テラステナント様専用サイト
        </h1>
        {user && (
          <p className="text-base text-gray-500 mt-2 ml-6">
            {user.shopName}　{user.regiNo}番レジ（{user.regiName}）
          </p>
        )}
      </header>

      {/* メインレイアウト: サイドバー + コンテンツ */}
      <div className="flex flex-1">
        <Sidebar
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          userType={user?.userType}
          widthClass="w-56"
          navButtonPaddingClass="px-4 py-4"
          navButtonTextSizeClass="text-base"
        />
        <main className="flex-1">
          <PageComponent
            onLogout={handleLogout}
            date={currentDate}
            onDateChange={setCurrentDate}
            onNavigateToStore={navigateToStore}
          />
        </main>
      </div>
    </div>
  );
}

export default App;
